<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @uploadFile="evgUploadFilesVisible = true"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <EvgUploadFiles
      :visible.sync="evgUploadFilesVisible"
      :fileType="fileType"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EvgUploadFiles from '@/views/ecom/components/evg-upload-files'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, EvgUploadFiles },
  data() {
    return { usePage: true, evgUploadFilesVisible: false, fileType: 'WMPOSSALES' }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomEvgFileListApi({
          listFileType: [this.fileType],
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
